// Externals
import React from "react";

// Styles
import "./Header2.scss";

/*::
type Props = {}
*/
const Header2 = (props /*: Props */) /*: React.Component */ => {
	return (
		<>
			<header className="header-2">
				<h1>RSPCA COMPETIBLE</h1>
			</header>
		</>
	);
};

// Exports
export default Header2;
